import api from '../api/axios';

function buildAnalyticsParams({ from, to, recruiterId, teamLeadId, statsFrom, statsTo } = {}) {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  if (recruiterId) params.recruiterId = recruiterId;
  if (teamLeadId) params.teamLeadId = teamLeadId;
  if (statsFrom) params.statsFrom = statsFrom;
  if (statsTo) params.statsTo = statsTo;
  return params;
}

export const getAdminAnalytics = (filters = {}) =>
  api.get('/api/admin/analytics', { params: buildAnalyticsParams(filters) }).then((r) => r.data);

export const getAdminSourceProfiles = ({ from, to } = {}) => {
  const params = {};
  if (from) params.from = from;
  if (to) params.to = to;
  return api.get('/api/admin/source-profiles', { params }).then((r) => r.data);
};

export const getRequirementFunnel = (requirementId) =>
  api.get(`/api/admin/requirements/${requirementId}/funnel`).then((r) => r.data);

export const getRequirementSummary = (requirementId) =>
  api.get(`/api/requirements/${requirementId}/summary`).then((r) => r.data);
